export const W=390, H=844;
export const COLORS={sky:0xdff4ff,ink:0x5148d9,purple:0x5c54e8,yellow:0xffd85a,ground:0x78c66b,dirt:0x9a633f,dark:0x253449,white:0xffffff,red:0xed5b5b};
